import {
  enableProdMode,
  ErrorHandler,
  LOCALE_ID,
  importProvidersFrom,
  provideZoneChangeDetection,
} from "@angular/core";
import { bootstrapApplication, BrowserModule } from "@angular/platform-browser";
import { provideRouter, withViewTransitions } from "@angular/router";
import { AppComponent } from "./app/app.component";
import { environment } from "./environments/environment";
import { _routes } from "src/app/app-routing.module";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import {
  HTTP_INTERCEPTORS,
  HttpClient,
  provideHttpClient,
  withInterceptorsFromDi,
} from "@angular/common/http";
import {
  NotificationsService,
  SimpleNotificationsModule,
} from "angular2-notifications";
import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { ServiceWorkerModule } from "@angular/service-worker";
import { NgxSmartModalModule } from "ngx-smart-modal";
import { SModule } from "src/app/SayTS/s.module";
import {
  CustomTranslateLoader,
  MissingTranlationConfig,
} from "src/app/SayTS/custom-translation";
import { AuthInterceptor } from "src/app/SayTS/auth.interceptor";
import { AccessGuard } from "src/app/SayTS/access-guard";
import { DeactivateGuard } from "src/app/SayTS/deactivate-guard";
import { ErrorService } from "src/app/SayTS/error.service";
import { registerLocaleData } from "@angular/common";

import localeCs from "@angular/common/locales/cs";
import localeDe from "@angular/common/locales/de";

registerLocaleData(localeCs);
registerLocaleData(localeDe);

if (environment.production) {
  enableProdMode();
}

// Nasazená verze se NEzapéká do buildu (jinak by se cache `npm run prod` invalidovala
// při každém pushi — viz docker/Dockerfile). Entrypoint kontejneru zapíše za běhu
// /version.json (mimo service-worker scope); načteme ho PŘED bootstrapem a přepíšeme
// environment.version, takže všechna stávající čtení (hlavička, i18n cache-busting,
// error report) dostanou přesnou nasazenou verzi. Fallback = verze z environment.ts
// (lokální dev nebo když /version.json chybí).
function startApp() {
  return bootstrapApplication(AppComponent, {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(_routes, withViewTransitions()),
    provideHttpClient(withInterceptorsFromDi()),
    importProvidersFrom(
      BrowserModule,
      BrowserAnimationsModule,
      SimpleNotificationsModule.forRoot(),
      TranslateModule.forRoot({
        defaultLanguage: "en",
        loader: {
          provide: TranslateLoader,
          useClass: CustomTranslateLoader,
          deps: [HttpClient, NotificationsService],
        },
        ...MissingTranlationConfig,
      }),
      ServiceWorkerModule.register(`${environment.clientBase}ngsw-worker.js`, {
        enabled: environment.production,
        registrationStrategy: "registerWhenStable:30000",
      }),
      NgxSmartModalModule.forRoot(),
      SModule,
    ),
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: LOCALE_ID, useValue: "en-US" },
    { provide: ErrorHandler, useClass: ErrorService },
    AccessGuard,
    DeactivateGuard,
  ],
  }).catch((err) => console.error(err));
}

fetch("version.json", { cache: "no-store" })
  .then((res) => (res.ok ? res.json() : null))
  .then((data) => {
    if (data && typeof data.version === "string" && data.version) {
      environment.version = data.version;
    }
  })
  .catch(() => {
    /* /version.json nedostupné → necháme zapečenou environment.version z buildu */
  })
  .finally(() => startApp());
